// 이미지 파일들을 import
import MapIcon from './icon_map.svg';
import SettingIcon from './icon_setting.svg';
// ... 다른 이미지 파일들 import

// 이미지 객체로 export
export const IMAGES = {
  MapIcon,
  SettingIcon,
} as const;

export type ImageKeyType = keyof typeof IMAGES;
